<template>
  <label v-if="checkboxSide !== 'right'">
    <input type="checkbox" :value="val" v-model="checked" @change="onChange">
    <span class="checkbox-left"></span>

    <div class="content-right">
      <slot></slot>
    </div>
  </label>

  <label v-else>
    <input type="checkbox" :value="val" v-model="checked" @change="onChange">
    <span class="checkbox-right"></span>

    <div class="content-left">
      <slot></slot>
    </div>
  </label>
</template>

<script>
export default {
  name: 'large-checkbox',
  props: {
    checkboxSide: {
      type: String,
      default: 'left',
    },
    value: {},
    val: {},
  },
  data() {
    return {
      checkedProxy: false,
    };
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(val) {
        this.checkedProxy = val;
      },
    },
  },
  methods: {
    onChange() {
      this.$emit('input', this.checkedProxy);
    },
  },
};
</script>

<style lang="sass" scoped>
input
  display: none

label input[type=checkbox] ~ span
  display: inline-block
  vertical-align: middle
  cursor: pointer
  background: #FFF
  border: 1px solid #888
  padding: 1px
  height: 20px
  width: 20px

.checkbox-left
  float: left

.checkbox-right
  float: right

label input[type=checkbox]:checked ~ span
  // image: Picol.org, cc-by 3.0, https://commons.wikimedia.org/wiki/File:Accept_Picol_icon.svg
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M14 18L26 6l4 4-16 16L4 16l4-4z"/></svg>')
  background-size: 100%

.content-right
  display: block
  vertical-align: middle
  padding-left: 25px

.content-left
  display: block
  vertical-align: middle
  padding-right: 25px
  text-align: right

</style>




// WEBPACK FOOTER //
// src/components/LargeCheckbox.vue